// PhoneInput.jsx
import InputMask from "react-input-mask";
import React from "react";

function selectMask(v = "", fallback = "(99) 99999-9999") {
  const digits = (v || "").replace(/\D/g, "");
  // se tiver 11 dígitos (celular), usa 99999; se 10 (fixo), usa 9999
  return digits.length === 10 ? "(99) 99999-9999" : fallback;
}

const PhoneInput = ({
  label,
  name,
  value,
  onChange,
  onBlur,
  error,
  type = "text",
  mask = "AUTO", // AUTO = escolhe pela quantidade de dígitos
  required,
  ...props
}) => {
  const appliedMask =
    mask === "AUTO"
      ? selectMask(value)
      : mask === "DEFAULT"
      ? "(99) 99999-9999"
      : "(99)999999999";

  return (
    <>
      <div className="w-full relative">
        <InputMask
          id={name}
          name={name}
          type={type}
          className="block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 bg-transparent rounded-lg border-1 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
          placeholder=""
          value={value ?? ""}
          onChange={onChange}
          onBlur={onBlur}
          mask={appliedMask}
          maskChar=""
          alwaysShowMask={false}
          {...props}
        />
        <label
          htmlFor={name}
          className="absolute text-md text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-2 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1"
        >
          {label}
        </label>
      </div>
      {error && <small className="text-red-400">{error}</small>}
    </>
  );
};

export default PhoneInput;
